import { render } from "./Dashboard.vue?vue&type=template&id=670816e9&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=670816e9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-670816e9"

export default script